import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PublicNav from "@/components/PublicNav";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Check, Star } from "lucide-react";
import { toast } from "sonner";

export default function Pricing() {
  const [pkgs, setPkgs] = useState([]);
  const nav = useNavigate();
  const { user } = useAuth();
  useEffect(() => {
    api.get("/packages").then(r => setPkgs(r.data)).catch(() => {});
  }, []);

  const pick = (pkg) => {
    try { localStorage.setItem("coachjp_pkg", pkg.id); } catch {}
    if (!user) {
      toast.message("Create your account to continue");
      nav("/register");
    } else {
      nav("/payment");
    }
  };

  return (
    <div className="min-h-screen bg-[#070707] text-white" data-testid="pricing-page">
      <PublicNav />
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-12 sm:py-20">
        <div className="font-mono-jp text-xs tracking-[0.3em] uppercase text-[#d7ff00]">STEP 03 · PICK YOUR PATH</div>
        <h1 className="mt-3 font-display text-5xl sm:text-7xl uppercase leading-[0.9]">Choose your <span className="text-[#d7ff00]">package</span></h1>
        <p className="mt-4 text-[#bbb] max-w-xl">Self-guided programs, coach-supported plans, or the elite ultimate performance ecosystem. Cancel anytime.</p>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {pkgs.map(p => (
            <div key={p.id}
              className={`relative bg-[#0a0a0a] border ${p.highlight ? "border-[#d7ff00] jp-shadow-glow" : "border-[#1f1f1f]"} p-6 flex flex-col`}
              data-testid={`pkg-${p.id}`}>
              {p.highlight && (
                <div className="absolute -top-3 left-6 bg-[#d7ff00] text-black font-mono-jp text-[10px] tracking-widest uppercase px-2 py-1 inline-flex items-center gap-1">
                  <Star className="w-3 h-3" /> Most Popular
                </div>
              )}
              <div className="font-mono-jp text-[10px] tracking-[0.3em] uppercase text-[#888]">{p.tier?.toUpperCase()}</div>
              <div className="mt-2 font-display text-3xl uppercase">{p.name}</div>
              <div className="mt-4 flex items-baseline gap-1">
                <span className="font-display text-5xl text-[#d7ff00] tick">{p.currency} {p.price}</span>
                {p.period && <span className="font-mono-jp text-xs text-[#888]">{p.period}</span>}
              </div>
              {p.pay_in_full_note && (
                <div className="mt-1.5 font-mono-jp text-[11px] text-[#71c4ff]" data-testid={`pkg-payfull-${p.id}`}>{p.pay_in_full_note}</div>
              )}
              <ul className="mt-6 space-y-2 text-sm text-[#ddd] flex-1">
                {p.features?.map(f => (
                  <li key={f} className="flex gap-2"><Check className="w-4 h-4 text-[#d7ff00] mt-0.5" /> {f}</li>
                ))}
              </ul>
              <button onClick={() => pick(p)} className={`mt-6 ${p.highlight ? "bg-[#d7ff00] text-black hover:bg-white" : "bg-[#111] text-white border border-[#222] hover:border-[#d7ff00]"} font-display tracking-wider uppercase py-3`} data-testid={`pkg-select-${p.id}`}>
                Select Plan
              </button>
            </div>
          ))}
        </div>

        <p className="mt-10 text-center text-xs text-[#888] font-mono-jp tracking-widest uppercase">Country pricing in RM · USD · EUR · GBP — auto-detected at checkout</p>
      </div>
    </div>
  );
}
